import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Gallery.css';

const ALL_IMAGES = [
  // Manta Ray 420 (21 images)
  { src: '/gallery/mantaray420/m1.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m2.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m3.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m4.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m5.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m6.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m7.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m8.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m9.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m10.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m11.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m12.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m13.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m14.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m15.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m16.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m17.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m18.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m19.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m20.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  { src: '/gallery/mantaray420/m21.webp', model: 'mantaray420', label: 'Manta Ray 420' },
  // STIA 580 (21 unique images)
  { src: '/gallery/stia580/p1.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p2.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p3.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p4.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p5.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p6.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p7.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p8.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p9.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p11.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p12.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p13.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p14.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p15.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p16.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p18.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p20.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p22.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p23.webp', model: 'stia580', label: 'STIA 580' },
  { src: '/gallery/stia580/p24.webp', model: 'stia580', label: 'STIA 580' },
  // Real 500 (14 unique images)
  { src: '/gallery/real500/r1.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r2.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r3.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r4.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r5.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r6.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r7.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r8.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r9.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r10.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r11.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r12.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r13.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r14.webp', model: 'real500', label: 'Real 500' },
  { src: '/gallery/real500/r15.webp', model: 'real500', label: 'Real 500' },
];

const FILTERS = [
  { key: 'all' },
  { key: 'stia580', label: 'STIA 580' },
  { key: 'real500', label: 'Real 500' },
  { key: 'mantaray420', label: 'Manta Ray 420' },
];

function Gallery() {
  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightbox, setLightbox] = useState(null); // index into filtered array

  const filtered = activeFilter === 'all'
    ? ALL_IMAGES
    : ALL_IMAGES.filter((img) => img.model === activeFilter);

  const openLightbox = (i) => setLightbox(i);
  const closeLightbox = () => setLightbox(null);
  const prev = () => setLightbox((i) => (i - 1 + filtered.length) % filtered.length);
  const next = () => setLightbox((i) => (i + 1) % filtered.length);

  const handleKeyDown = (e) => {
    if (lightbox === null) return;
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'Escape') closeLightbox();
  };

  return (
    <div className="gallery-page" onKeyDown={handleKeyDown} tabIndex={-1}>
      <SEO
        title="Gallery — Unimar Fiberglass Boats"
        description="Browse photos of Unimar boats — the Manta Ray 420, STIA 580, and Real 500. See our fiberglass boat construction, design details, and on-water performance shots."
        url="/gallery"
        image="/unimar-boats-collection.webp"
      />
      <Header />

      {/* Hero */}
      <section className="gallery-hero">
        <img src="/unimar-boats-collection.webp" alt="Unimar Gallery" className="gallery-hero__img" />
        <div className="gallery-hero__overlay" />
        <h1 className="gallery-hero__title">{t('galleryPage.title')}</h1>
      </section>

      {/* Filters */}
      <div className="gallery-filters">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            className={`gallery-filter ${activeFilter === f.key ? 'gallery-filter--active' : ''}`}
            onClick={() => setActiveFilter(f.key)}
          >
            {f.key === 'all' ? t('galleryPage.filterAll') : f.label}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="gallery-grid">
        {filtered.map((img, i) => (
          <div key={img.src} className="gallery-item" onClick={() => openLightbox(i)}>
            <img src={img.src} alt={img.label} loading="lazy" decoding="async" />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div className="gallery-lightbox" onClick={closeLightbox}>
          <button className="gallery-lightbox__close" onClick={closeLightbox}>✕</button>
          <button className="gallery-lightbox__arrow gallery-lightbox__arrow--prev" onClick={(e) => { e.stopPropagation(); prev(); }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
          <img
            src={filtered[lightbox].src}
            alt={filtered[lightbox].label}
            className="gallery-lightbox__img"
            onClick={(e) => e.stopPropagation()}
          />
          <button className="gallery-lightbox__arrow gallery-lightbox__arrow--next" onClick={(e) => { e.stopPropagation(); next(); }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
          <div className="gallery-lightbox__counter">{t('galleryPage.counter', { current: lightbox + 1, total: filtered.length })}</div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Gallery;
